import React, { Component } from 'react';
import { isEmpty, size } from 'lodash'
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import AddCircle from '@mui/icons-material/AddCircle';
import SwapHorizontalCircle from '@mui/icons-material/SwapHorizontalCircle';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/material';

class FileUpload extends Component {
    state = {
        files: this.props.files || [],
        max: this.props.max || 4,
    }

    componentDidUpdate(prevProps) {
        if (prevProps.files !== this.props.files) {
            this.setState({
                ...this.state,
                files: this.props.files || [],
            });
        }
    }

    onRemoveImage = async (e, index) => {
        e.preventDefault();
        let files = [
          ...this.state.files.slice(0,index), 
          ...this.state.files.slice(index+1)
        ]
        this.setState({
          ...this.state,
          files
        });
        this.props.setFiles(files)// send setFiles to Products component
      }

    handleAddImage = async (e) => {
        e.preventDefault();
        let exist = this.state.files.length;
        let list = e.target.files;

        console.log("[INFO], Upload Image list", list);

        let max = (exist + list.length) > this.state.max ? (this.state.max - exist) : list.length// 4 pics max

        if(!list){
            return
        }

        for (let i = 0; i < max; i++) {
            let reader = new FileReader();
            let file = list[i];
            reader.onloadend = async (upload) => {
                console.log("[INFO]onloadend upload reader ", reader);
                this.setState((prevState) => ({ 
                    ...prevState,  
                    files:[
                        ...prevState.files, 
                        { 
                            "data_uri": upload.target.result, 
                            "filename": file.name,
                            "filetype": file.type,
                        }
                    ]
                }), () => this.props.setFiles(this.state.files))
            }
            await reader.readAsDataURL(file) // ??
        }
    }
    

    handleChange(e, index) {
        e.preventDefault();
        console.log("[INFO], Upload One Image", index);

        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = (upload) => {
            let files = [...this.state.files]
            console.log('====================================');
            console.log("Upload files change index",{index, files});
            console.log('====================================');
            files[index] = {
                "data_uri": upload.target.result, 
                "filename": file.name,
                "filetype": file.type,
            }
            this.setState({
                ...this.state,
                files,
            }, () => this.props.setFiles(this.state.files));
        }

        reader.readAsDataURL(file)
    }

    getFilePreviewSrc = (file) => {
        if (!file) return "";
        if (file.data_uri) return file.data_uri;
        if (file.filename) return `/photos/single/${file.filename}`;
        return "";
    }
    
    render() {
        console.log("[STATE] FILES", this.state.files, size(this.state.files));
        const { files, max } = this.state;
        const { saved, fullWidth } = this.props;
        const displayFiles = !isEmpty(files) ? files : (saved || []);
        return (
            <Box>
                <input 
                    id="photo-input"
                    type="file" 
                    hidden
                    multiple
                    onChange={this.handleAddImage }
                />
                {(size(displayFiles) < max) &&  
                    <Button 
                        startIcon={<AddCircle />}
                        style={{ width: fullWidth && "100%"}} 
                        variant="contained" color="primary" component="label" htmlFor="photo-input" className="photoinput-new"
                    >
                         {this.props.label || "Ajouter une Photo"}
                    </Button>
                }
                {/* {!isEmpty(saved) && isEmpty(files) && saved.map( file => 
                    <div className="photoinput photoinput-exists" data-provides="photoinput">
                        <div 
                            className="photoinput-preview thumbnail" 
                            data-trigger="photoinput" 
                            style={{maxWidth: "250px", margin: "auto"}}
                        >
                            <img src={saved} className="image"/>
                        </div>

                        <div>
                        <IconButton color="secondary" component="label" htmlFor="photo-input"  >
                            <SwapHorizontalCircle /> 
                        </IconButton>
                            Modifier
                        </div>
                    </div>
                )
                } */}
                <Grid container spacing={2} >
                    {!isEmpty(displayFiles) && displayFiles.map( (file, i) => (
                        <Grid key={`${file.filename || "file"}-${i}`} item sm={2} xs={6}>
                            <div className="photoinput photoinput-exists" data-provides="photoinput">
                                <div 
                                    className="photoinput-preview thumbnail" 
                                    data-trigger="photoinput" 
                                    style={{maxWidth: "250px", margin: "auto"}}
                                >
                                    <img src={this.getFilePreviewSrc(file)} className="image"/>
                                </div>

                                <div>
                                    {/* <IconButton color="secondary" component="label" htmlFor="photo-update"  >
                                        <SwapHorizontalCircle />
                                        <input id="photo-update" type="file" name="File" hidden onChange={(e) => this.handleChange(e, i)}/>
                                    </IconButton> */}
                                    <IconButton
                                        color="secondary"
                                        component="label"
                                        onClick={(e) => this.onRemoveImage(e, i)}
                                        size="large">
                                        <DeleteIcon />
                                    </IconButton>
                                </div>
                            </div>
                        </Grid>
                    ))
                    }
                </Grid>
            </Box>
        );
    }
}

export default FileUpload
